import type { FC, SVGProps } from 'react'

export const Alert: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.99992 1.33329C11.6818 1.33329 14.6666 4.31806 14.6666 7.99996C14.6666 11.6819 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6819 1.33325 7.99996C1.33325 4.31806 4.31802 1.33329 7.99992 1.33329Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 5.33333V8" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8 10.6666H8.00667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
